// extracted by mini-css-extract-plugin
module.exports = {"svg":"upload_svg__1rdBv","pathBox":"upload_pathBox__2DBnT","arrow":"upload_arrow__3cNPz","youtube":"upload_youtube__37DZj"};